import { render, staticRenderFns } from "./ShippingServiceOptions.vue?vue&type=template&id=2800d7f6&scoped=true"
import script from "./ShippingServiceOptions.vue?vue&type=script&lang=js"
export * from "./ShippingServiceOptions.vue?vue&type=script&lang=js"
import style0 from "./ShippingServiceOptions.vue?vue&type=style&index=0&id=2800d7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2800d7f6",
  null
  
)

export default component.exports